import { render, staticRenderFns } from "./AccessAdministratorList.vue?vue&type=template&id=79fe30c9&scoped=true&"
import script from "./AccessAdministratorList.vue?vue&type=script&lang=js&"
export * from "./AccessAdministratorList.vue?vue&type=script&lang=js&"
import style0 from "./AccessAdministratorList.vue?vue&type=style&index=0&id=79fe30c9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fe30c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
